import React from "react";
import CustomSelect from "../common/Select";

const opcionesIdentidadGenero = [
  { value: "01", label: "MASCULINO" },
  { value: "02", label: "FEMENINO" },
  { value: "03", label: "TRANSGÉNERO" },
  { value: "04", label: "NEUTRO" },
  { value: "05", label: "NO LO DECLARA" }
];

function SelectorIdentidadGenero({ value, onChange, error, required = false }) {
  return (
    <CustomSelect
      options={opcionesIdentidadGenero}
      value={value}
      onChange={onChange}
      placeholder="Genero"
      label="Identidad de género"
      error={error}
      required={required}
    />
  );
}

export default SelectorIdentidadGenero;